import { NgtUniversalModule } from '@ng-toolkit/universal';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { FooterComponent } from './components/footer/footer.component';
import { PetService } from './services/pets.service';
import { CartService } from './services/cart.service';
import { ApiService } from './services/api.service';
import { SEOService } from './services/seo.service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule } from '@angular/forms';
import { TransferHttpModule, TransferHttpService } from '@gorniv/ngx-universal';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScriptService } from './services/script.service';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { AirComponent } from './components/air/air.component';
import { OceanComponent } from './components/ocean/ocean.component';
import { TrainComponent } from './components/train/train.component';
import { RoadComponent } from './components/road/road.component';
import { QuoteComponent } from './components/quote/quote.component';
import { ResultComponent } from './components/result/result.component';
import { TrackComponent } from './components/track/track.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    AboutComponent,
    ContactComponent,
    AirComponent,
    OceanComponent,
    TrainComponent,
    RoadComponent,
    QuoteComponent,
    ResultComponent,
    TrackComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    BrowserModule.withServerTransition({ appId: 'app-root' }),
    CarouselModule,
    CommonModule,
    NgtUniversalModule,
    TransferHttpCacheModule,
    TransferHttpModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
  ],
  providers: [
    ScriptService,
    ApiService,
    SEOService,
    TransferHttpService
  ],
})
export class AppModule { }
